/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Icon for this entity type
 * @export
 * @interface IconRef
 */
export interface IconRef {
    /**
     * 
     * @type {string}
     * @memberof IconRef
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof IconRef
     */
    title?: string;
}

/**
 * Check if a given object implements the IconRef interface.
 */
export function instanceOfIconRef(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function IconRefFromJSON(json: any): IconRef {
    return IconRefFromJSONTyped(json, false);
}

export function IconRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): IconRef {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function IconRefToJSON(value?: IconRef | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'title': value.title,
    };
}

